import loadable from '@loadable/component';

export const ManageListingsPageLoadable = loadable(
  () => import('./ManageListingsPage'),
  { resolveComponent: (module) => module.ManageListingsPage },
);
